import { SVGProps } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Accordion, AccordionButton, AccordionPanel, Spacing } from '@zep/ui';
import { Button } from '@zep/ui/experimental';
import { isMobile } from '@zep/utils/device';
import { PricingCardProps } from '../../types';
import { PricingCard } from '../PricingCard';
import { FeatureListItem } from './shared';
export const BasicPlanCard = (props: PricingCardProps) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    locale
  } = useRouter();
  return <PricingCard.Root data-sentry-element="unknown" data-sentry-component="BasicPlanCard" data-sentry-source-file="BasicPlanCard.tsx">
      <PricingCard.Header data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
        <div className="flex">
          <div className="flex w-full flex-col">
            <PricingCard.Title data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">Basic</PricingCard.Title>
            <PricingCard.TitleDescription data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
              {t('subscription:pricing.basic.description')}
            </PricingCard.TitleDescription>
          </div>
          <PricingCard.Logo data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
            <PersonStackFillIconSvg data-sentry-element="PersonStackFillIconSvg" data-sentry-source-file="BasicPlanCard.tsx" />
          </PricingCard.Logo>
        </div>
      </PricingCard.Header>
      <PricingCard.Content className="flex flex-col items-start" data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
        <PricingCard.Price pricePerUser={props.pricePerUser ?? 0} data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx" />
        <Spacing size={14} data-sentry-element="Spacing" data-sentry-source-file="BasicPlanCard.tsx" />
        <Button className="h-[40px] w-full !bg-mintDark hover:!bg-mintDark-hover" onClick={props.onClickCardButton} data-sentry-element="Button" data-sentry-source-file="BasicPlanCard.tsx">
          {t('subscription:pricing.startButton')}
        </Button>
        {locale === 'ko' && <div className="w-full">
            <Spacing size={6} />
            <Button size="xs" intent="sub" variant="transparent" className="h-[30px] w-full" onClick={() => {
          window.open(`https://zepschool.us/quote/core/?plan=basic&term=${props.coreQuoteTerm ?? '1'}`, '_blank');
        }}>
              {t('subscription:pricing.12734dd4')}
            </Button>
          </div>}
      </PricingCard.Content>
      <PricingCard.Footer data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
        {isMobile() ? <Accordion className="!border-none !bg-white">
            <AccordionButton className="text-body-1-sb justify-between !p-0 !text-[14px] font-[600] text-gray-900">
              {t('subscription:pricing.mainFeatures')}
            </AccordionButton>
            <AccordionPanel className="!p-0">
              <Spacing size={16} />
              <FooterContent />
              <Spacing size={14} />
            </AccordionPanel>
          </Accordion> : <FooterContent />}
      </PricingCard.Footer>
    </PricingCard.Root>;
};
const FooterContent = () => {
  const {
    t
  } = useTranslation(['subscription']);
  return <div className="flex flex-col" data-sentry-component="FooterContent" data-sentry-source-file="BasicPlanCard.tsx">
      <PricingCard.FeatureTitle data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
        {t('subscription:pricing.basic.feature1')}
      </PricingCard.FeatureTitle>
      <Spacing size={16} data-sentry-element="Spacing" data-sentry-source-file="BasicPlanCard.tsx" />
      <FeatureListItem.Root data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
            {t('subscription:pricing.oOskLOD6')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
            {t('subscription:pricing.basic.spotlightUnlimited')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
            {t('subscription:pricing.basic.screenShareUnlimited')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
            {t('subscription:planFeatures.spaceSearchVisibility')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
            {t('subscription:planFeatures.spacePassword')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
            {t('subscription:pricing.basic.loginUserOnly')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
            {t('subscription:pricing.basic.domainRestriction')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
        <FeatureListItem.List data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
          <FeatureListItem.Icon data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx" />
          <FeatureListItem.Text data-sentry-element="unknown" data-sentry-source-file="BasicPlanCard.tsx">
            {t('subscription:pricing.basic.entryTitle')}
          </FeatureListItem.Text>
        </FeatureListItem.List>
      </FeatureListItem.Root>
    </div>;
};
const PersonStackFillIconSvg = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" {...props} data-sentry-element="svg" data-sentry-component="PersonStackFillIconSvg" data-sentry-source-file="BasicPlanCard.tsx">
    <path fill="url(#from-a)" d="M4.667 9.333a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z" data-sentry-element="path" data-sentry-source-file="BasicPlanCard.tsx" />
    <path fill="url(#via-b)" d="M3.5 25.667A1.167 1.167 0 0 1 2.335 24.5a5.833 5.833 0 0 1 5.833-5.833h7a5.833 5.833 0 0 1 5.834 5.833c0 .644-.523 1.167-1.167 1.167H3.501Z" data-sentry-element="path" data-sentry-source-file="BasicPlanCard.tsx" />
    <path fill="url(#via-c)" d="M21.284 4.384a1.167 1.167 0 1 0-1.65 1.65 4.667 4.667 0 0 1 0 6.6 1.167 1.167 0 0 0 1.65 1.65 7 7 0 0 0 0-9.9Z" data-sentry-element="path" data-sentry-source-file="BasicPlanCard.tsx" />
    <path fill="url(#to-d)" d="M21.867 18.702a1.167 1.167 0 1 0-.566 2.263c.784.196 1.262.664 1.573 1.286.33.659.46 1.482.46 2.25a1.167 1.167 0 1 0 2.333 0c0-.984-.16-2.202-.706-3.294-.564-1.128-1.545-2.118-3.094-2.505Z" data-sentry-element="path" data-sentry-source-file="BasicPlanCard.tsx" />
    <defs data-sentry-element="defs" data-sentry-source-file="BasicPlanCard.tsx">
      <linearGradient id="from-a" x1={14.001} x2={14.001} y1={2.333} y2={25.667} gradientUnits="userSpaceOnUse" data-sentry-element="linearGradient" data-sentry-source-file="BasicPlanCard.tsx">
        <stop stopColor="#05B8A2" data-sentry-element="stop" data-sentry-source-file="BasicPlanCard.tsx" />
        <stop offset={1} stopColor="#72D3E7" data-sentry-element="stop" data-sentry-source-file="BasicPlanCard.tsx" />
      </linearGradient>
      <linearGradient id="via-b" x1={14.001} x2={14.001} y1={2.333} y2={25.667} gradientUnits="userSpaceOnUse" data-sentry-element="linearGradient" data-sentry-source-file="BasicPlanCard.tsx">
        <stop stopColor="#05B8A2" data-sentry-element="stop" data-sentry-source-file="BasicPlanCard.tsx" />
        <stop offset={1} stopColor="#72D3E7" data-sentry-element="stop" data-sentry-source-file="BasicPlanCard.tsx" />
      </linearGradient>
      <linearGradient id="via-c" x1={14.001} x2={14.001} y1={2.333} y2={25.667} gradientUnits="userSpaceOnUse" data-sentry-element="linearGradient" data-sentry-source-file="BasicPlanCard.tsx">
        <stop stopColor="#05B8A2" data-sentry-element="stop" data-sentry-source-file="BasicPlanCard.tsx" />
        <stop offset={1} stopColor="#72D3E7" data-sentry-element="stop" data-sentry-source-file="BasicPlanCard.tsx" />
      </linearGradient>
      <linearGradient id="to-d" x1={14.001} x2={14.001} y1={2.333} y2={25.667} gradientUnits="userSpaceOnUse" data-sentry-element="linearGradient" data-sentry-source-file="BasicPlanCard.tsx">
        <stop stopColor="#05B8A2" data-sentry-element="stop" data-sentry-source-file="BasicPlanCard.tsx" />
        <stop offset={1} stopColor="#72D3E7" data-sentry-element="stop" data-sentry-source-file="BasicPlanCard.tsx" />
      </linearGradient>
    </defs>
  </svg>;